import { request } from './request';

// 创业活动接口类型定义
export interface EnterpriseActivity {
  attachment: string;
  author: string;
  content: string;
  coverImage: string;
  id: number;
  publishTime: string;
  status: number;
  subtitle: string;
  summary: string;
  title: string;
  type: number;
}

export interface ActivityPageParams {
  pageNum: number;
  pageSize: number;
  type?: number; // 1-赛事 2-培训 3-路演 4-交流，不传代表查询所有
}

export interface ActivityPageResponse {
  code: number;
  data: EnterpriseActivity[];
  msg: string;
  total: number;
}

/**
 * 按照活动类型查询-分页
 * @param params 分页参数
 * @returns 活动列表
 */
export const getActivityPageListByType = (params: ActivityPageParams) => {
  return request.get('/enterprise_activity/pageListByType', params);
};

/**
 * 根据ID获取活动详情
 * @param id 活动ID
 * @returns 活动详情
 */
export const getActivityById = (id: number) => {
  return request.get(`/enterprise_activity/${id}`);
};

// 创业企业列表接口类型定义
export interface Entrepreneurship {
  content: string;
  id: number;
  name: string;
  settledTime: string;
}

export interface EntrepreneurshipListResponse {
  code: number;
  data: Entrepreneurship[];
  msg: string;
  total: number;
}

/**
 * 获取创业企业列表
 * @returns 创业企业列表
 */
export const getEntrepreneurshipList = () => {
  return request.get('/entrepreneurship/list');
};

/**
 * 根据ID获取创业企业详情
 * @param id 创业企业ID
 * @returns 创业企业详情
 */
export const getEntrepreneurshipById = (id: number) => {
  return request.get(`/entrepreneurship/${id}`);
};
